
import React, { useState, useEffect, useContext } from "react";
import quizThumb from '../assets/images/quiz-default.jpg';
import Footer from "../components/footer/Footer";
import tmdbApi from "../api/tmdbApi";
import Header from "../components/header/Header";
import { useHistory, Link, useLocation } from "react-router-dom";
import SweetAlert from 'react-bootstrap-sweetalert';
import moment from "moment";

const SignUp = () => {
    const history = useHistory();
    const { state } = useLocation();
    const { flag } = state || {};
    const [quizData, setQuizData] = useState(null);
    const [formData, setFormData] = useState({
        name: "", email: "", username: "", password: "", confirmpassword: "", designation: ""
    });
    const [handleExist, sethandleExist] = useState(false)
    const [errorData, setError] = useState({});
    const [errorDisplay, seterrorDisplay] = useState(false);
    const [imageCloudfront, setImg] = useState(false);
    const [showPwd, setShowPwd] = useState(false);
    const [showCnfPwd, setShowCnfPwd] = useState(false);
    const[success,setSuccess]=useState(false)
    useEffect(() => {
        if (localStorage.getItem("token1")) {
            history.push("/");
        }
    }, [])

    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }


    }, [window.site]);
    const onBackConfirm = async () => {
        sethandleExist(false);
        // setBackButtonPressed(true);


    }
    useEffect(() => {
        if (flag) {
            // Add event listener for popstate to detect when the user presses the back button
            const handlePopState = (event) => {
                event.preventDefault();
                history.push('/')

            };

            // Initially pushState to allow popstate to fire
            window.history.pushState({}, document.title, window.location.href);

            // Add popstate listener
            window.addEventListener("popstate", handlePopState);

            return () => {
                // Cleanup event listener when component unmounts
                window.removeEventListener("popstate", handlePopState);
            };
        }

    }, []);

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    //     let quizinfo = JSON.parse(localStorage.getItem('q'))
    //     if (quizinfo) {
    //         setQuizData(quizinfo)
    //     }
    //     let userinfo = JSON.parse(localStorage.getItem('u'))
    //     if (userinfo) {
    //         setFormData(userinfo)
    //     }
    // }, []);

    const handleChange = (event) => {
        const { name, value } = event.target;

        // Check if the field being updated is the phone number
        if (name === "phone") {
            // Validate phone number: only numbers and a maximum of 10 digits
            if (/^\d{0,10}$/.test(value)) {
                setFormData((prevData) => ({
                    ...prevData, // Keep the other fields intact
                    [name]: value, // Update the phone number field
                }));
            }
            seterrorDisplay(false)
        } else if (name === "name") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...errorData, name: "" })

        } else if (name === "email") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...errorData, email: "" })

        } else if (name === "username") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...errorData, username: "" })

        } else if (name === "password") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...errorData, password: "" })

        } else if (name === "confirmpassword") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...errorData, confirmpassword: "" })

        }else if (name === "designation") {
            // Validate phone number: only numbers and a maximum of 10 digits
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the phone number field
            }));

            setError({ ...errorData, designation: "" })

        } else {
            // Allow normal updates for other fields
            setFormData((prevData) => ({
                ...prevData, // Keep the other fields intact
                [name]: value, // Update the changed field
            }));
        }
    };

    console.log("formData :", formData);

    const handleSubmit = (e) => {
        const isValid = formvalidation();
        if (isValid) {
            handleSignUp()
        }


    }


    function formvalidation() {
        let formIsValid = true;

        // Name Validation
        if (formData?.name === "") {
            setError((prevData) => ({
                ...prevData,
                ["name"]: "Please enter name",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["name"]: "",
            }));
        }

        if (formData?.designation === "") {
            setError((prevData) => ({
                ...prevData,
                ["designation"]: "Please select designation",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["designation"]: "",
            }));
        }

        console.log("errorrrrrrrrrrrrrrrrrrrrrrr", errorData)
        // Username Validation
        if (formData?.username === "") {
            setError((prevData) => ({
                ...prevData,
                ["username"]: "Please enter username",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["username"]: "",
            }));
        }

        // Password Validation
        const uppercaseRegex = /[A-Z]/;
        const lowercaseRegex = /[a-z]/;
        const numberRegex = /\d/;
        // const specialCharRegex = /[@$!%*?&]/;

        if (formData?.password === "") {
            setError((prevData) => ({
                ...prevData,
                ["password"]: "Please enter password",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else if (!uppercaseRegex.test(formData.password)) {
            setError((prevData) => ({
                ...prevData,
                ["password"]: "Password must contain at least one uppercase letter",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else if (!lowercaseRegex.test(formData.password)) {
            setError((prevData) => ({
                ...prevData,
                ["password"]: "Password must contain at least one lowercase letter",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else if (!numberRegex.test(formData.password)) {
            setError((prevData) => ({
                ...prevData,
                ["password"]: "Password must contain at least one number",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["password"]: "",
            }));
        }

        // Confirm Password Validation
        if (formData?.confirmpassword === "") {
            setError((prevData) => ({
                ...prevData,
                ["confirmpassword"]: "Please enter confirm password",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else if (formData?.confirmpassword !== formData?.password) {
            setError((prevData) => ({
                ...prevData,
                ["confirmpassword"]: "Confirm Password does not match Password",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["confirmpassword"]: "",
            }));
        }

        // Email Validation
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (formData?.email === "") {
            setError((prevData) => ({
                ...prevData,
                ["email"]: "Please enter email",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else if (!emailRegex.test(formData?.email)) {
            setError((prevData) => ({
                ...prevData,
                ["email"]: "Please enter a valid Email address",
            }));
            seterrorDisplay(true);

            formIsValid = false;
        } else {
            setError((prevData) => ({
                ...prevData,
                ["email"]: "",
            }));
        }

        return formIsValid;
    }
    const onConfirm = () => {
        sethandleExist(false)
    }
    const onConfirm1 =()=>{
        history.push("/login")
        setSuccess(false)
       }
    const handleSignUp = async () => {
        try {
            const { confirmpassword, ...dataToSend } = formData;
            const response = await tmdbApi.signUp({
                ...dataToSend,
            });
            console.log(response);
            if (response?.statusCode == 200 && response?.result === "Invalid email or password") {
                setError(response?.result);
                setTimeout(function () { setError("") }, 3000);
                // setBtnLoader("")
            } else if (response?.result === "User already exists") {
                sethandleExist(true)

                // signoutsession()
                // setShowSessionPopup(true)
                // setBtnLoader("")
            } else {
                console.log(response)
                setSuccess(true)
            }

        } catch {
            console.log("error");
            // setBtnLoader("")
            setError("Invalid email or password");
            setTimeout(function () { setError("") }, 3000);
        }
    };

    const handleBack = (e) => {
        history.push("/");

    }

    //    console.log('quizData' , quizData, quizinfo)
    return (
        <main>
            <Header />
            <div className="form_block login_block">
                <div className="wrp">

                    <div className="form">
                        <div className="sign_up">
                            <h3 className="sub_title">Sign up</h3>
                            <div className="form-group">
                                <label>Name <span>*</span></label>
                                <input type="text" name="name" className="form-control" placeholder="Enter Name" onChange={handleChange} value={formData?.name} />
                                {errorDisplay && <span className="errormsg" style={{
                                    fontWeight: 'bold',
                                    color: 'red',
                                }}>{errorData?.name}</span>}
                            </div>
                            <div className="form-group">
                                <label>Email <span>*</span></label>
                                <input type="text" name="email" className="form-control" placeholder="Enter email" onChange={handleChange} value={formData?.email} />
                                {errorDisplay && <span className="errormsg" style={{
                                    fontWeight: 'bold',
                                    color: 'red',
                                }}>{errorData?.email}</span>}
                            </div>
                            <div className="form-group">
                                <label>Phone Number</label>
                                <input type="text" name="phone" className="form-control" placeholder="Enter Phone" onChange={handleChange} value={formData?.phone} />

                            </div>
                            <div className="form-group">
                                <label>Designation<span>*</span></label>
                                <select id="designation" className="form-control" onChange={handleChange} value={formData?.designation} name="designation">
                                    <option value="">Select Designation</option>
                                    <option value="Consultant Dermatologist">Consultant Dermatologist</option>
                                    <option value="Consultant Pathologist">Consultant Pathologist</option>
                                    <option value="Dermatopathologist">Dermatopathologist</option>
                                    <option value="Post-graduate Dermatology">Post-graduate Dermatology</option>
                                    <option value="Postgraduate- Pathology">Post-graduate Pathology</option>
                                </select>
                                {errorDisplay && <span className="errormsg" style={{
                                fontWeight: 'bold',
                                color: 'red',
                            }}>{errorData?.designation}</span>}
                            </div>
                            <div className="form-group">
                                <label>User Name <span>*</span></label>
                                <input type="text" name="username" className="form-control" onChange={handleChange} value={formData?.username} placeholder="User Name" />
                                {errorDisplay && <span className="errormsg" style={{
                                    fontWeight: 'bold',
                                    color: 'red',
                                }}>{errorData?.username}</span>}
                            </div>
                            <div className="form-group">
                                <label>Password <span>*</span></label>
                                <div className="position-relative">
                                    <input
                                        type={showPwd ? "text" : "password"}
                                        name="password"

                                        onChange={handleChange} value={formData?.password} placeholder="Password"
                                        className="form-control"

                                    />
                                    <span
                                        onClick={() => setShowPwd(!showPwd)}
                                        className="material-icons icon icon"
                                    >
                                        {showPwd ? "visibility_off" : "visibility"} {/* Use emojis or Unicode characters */}
                                    </span>
                                </div>
                                {errorDisplay && <span className="errormsg" style={{
                                    fontWeight: 'bold',
                                    color: 'red',
                                }}>{errorData?.password}</span>}
                            </div>
                            <div className="form-group">
                                <label>Confirm Password <span>*</span></label>
                                <div className="position-relative">
                                    <input
                                        type={showCnfPwd ? "text" : "password"}
                                        name="confirmpassword"

                                        onChange={handleChange} value={formData?.confirmpassword} placeholder="Password"
                                        className="form-control"

                                    />
                                    <span
                                        onClick={() => setShowCnfPwd(!showCnfPwd)}
                                        className="material-icons icon icon"
                                    >
                                        {showCnfPwd ? "visibility_off" : "visibility"} {/* Use emojis or Unicode characters */}
                                    </span>
                                </div>
                                {errorDisplay && <span className="errormsg" style={{
                                    fontWeight: 'bold',
                                    color: 'red',
                                }}>{errorData?.confirmpassword}</span>}
                            </div>

                            <div className="btns">
                                <button onClick={(e) => handleSubmit(e)} type="submit" class="vs_btn mr-10">Sign up</button>
                                <button onClick={(e) => handleBack(e)} type="submit" class="border_btn">Cancel</button>
                            </div>
                            <p className="text">Already have an account? <a href="/login" className="link"> Login Here</a></p>
                        </div>

                    </div>

                    <SweetAlert show={handleExist}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"User already exist"}
                        onConfirm={e => onConfirm()}
                    >
                    </SweetAlert>
                    <SweetAlert show={success}
                        custom
                        confirmBtnText="ok"
                        confirmBtnBsStyle="primary"
                        title={"account created successfully"}
                        onConfirm={e => onConfirm1()}
                    >
                    </SweetAlert>

                </div>
            </div>
            <Footer />
        </main>
    );
};

export default SignUp;
